import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPin, IndianRupee, Home, Users, User } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";

const prefBadge = (pref, t) => {
  if (pref === "family") return { label: `👨‍👩‍👦 ${t("family_preferred")}`, cls: "bg-rose-100 text-rose-800 border-rose-300" };
  if (pref === "bachelor") return { label: `🧘 ${t("bachelor_preferred")}`, cls: "bg-sky-100 text-sky-800 border-sky-300" };
  return { label: `🕉️ ${t("no_pref")}`, cls: "bg-stone-100 text-stone-700 border-stone-300" };
};

export default function TempleCard({ temple }) {
  const { t } = useApp();
  const nav = useNavigate();
  const pb = prefBadge(temple.archaka_preference, t);

  return (
    <Card data-testid={`temple-card-${temple.id}`} className="overflow-hidden bg-surface gold-border temple-shadow hover:-translate-y-1 transition-transform duration-300 rounded-2xl group">
      <div className="relative h-40 overflow-hidden bg-gradient-to-br from-marigold/30 to-saffron/20">
        {temple.temple_photos?.length ? (
          <img src={temple.temple_photos[0]} alt={temple.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-6xl">🛕</div>
        )}
        <div className="absolute top-2 left-2"><Badge className={`border ${pb.cls} font-telugu text-[10px]`}>{pb.label}</Badge></div>
        {temple.status === "paused" && <div className="absolute top-2 right-2"><Badge variant="destructive" className="font-telugu">నిలిపివేయబడింది</Badge></div>}
      </div>
      <div className="p-4 space-y-3">
        <div>
          <h3 className="font-serifte font-bold text-maroon text-lg leading-tight line-clamp-1">{temple.name}</h3>
          <p className="text-sm text-saffron font-telugu">{temple.deity}</p>
        </div>
        <div className="flex items-center gap-1 text-xs text-muted-foreground font-telugu">
          <MapPin className="w-3.5 h-3.5 text-saffron" /> {temple.village}, {temple.mandal}, {temple.district}
        </div>
        <div className="flex flex-wrap gap-1.5">
          <Badge variant="outline" className="border-goldline/50 text-maroon font-telugu text-[11px]">
            <IndianRupee className="w-3 h-3 mr-0.5" />{(temple.salary || 0).toLocaleString("en-IN")}/నెల
          </Badge>
          {temple.ddn && <Badge variant="outline" className="border-goldline/50 text-maroon font-telugu text-[11px]">🪔 DDN</Badge>}
          {temple.accommodation && <Badge variant="outline" className="border-goldline/50 text-maroon font-telugu text-[11px]"><Home className="w-3 h-3 mr-0.5" />{temple.house_type || "వసతి"}</Badge>}
          {temple.free_food && <Badge variant="outline" className="border-goldline/50 text-maroon font-telugu text-[11px]">🍲 భోజనం</Badge>}
        </div>
        <Button data-testid={`temple-view-${temple.id}`} onClick={() => nav(`/temples/${temple.id}`)} className="w-full btn-sacred border-0 font-telugu">
          {t("view_details")}
        </Button>
      </div>
    </Card>
  );
}
